import { Controller } from "@hotwired/stimulus"
import { Swipers } from "../web/dx/components/Swipers";

const SWIPE_THRESHOLD = 50;

// Connects to data-controller="jolifish-swiper"
export default class extends Controller {
  connect() {
    this.swiper = new Swipers().init(this.element);

    // When navigation is handled by links (server-side slides), Swiper has a single
    // slide and won't react to gestures, so we detect swipes ourselves.
    if (this.hasLinkNavigation()) {
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.element.addEventListener("touchstart", this.onTouchStart, { passive: true });
      this.element.addEventListener("touchend", this.onTouchEnd, { passive: true });
    }
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this.onTouchStart);
    this.element.removeEventListener("touchend", this.onTouchEnd);
    this.swiper?.destroy();
    this.swiper = undefined;
  }

  nextSlide() {
    const el = this.swiper?.navigation?.nextEl;
    if (!el) return;
    if (el.parentElement.nodeName === "A") {
      el.parentElement.click();
    } else {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    const el = this.swiper?.navigation?.prevEl;
    if (!el) return;

    if (el.parentElement.nodeName === "A") {
      el.parentElement.click();
    } else {
      this.swiper.slidePrev();
    }
  }

  hasLinkNavigation() {
    const { nextEl, prevEl } = this.swiper?.navigation ?? {};
    return [nextEl, prevEl].some((el) => el?.parentElement?.nodeName === "A");
  }

  onTouchStart(event) {
    if (event.touches.length !== 1) {
      this.touchStart = undefined;
      return;
    }

    const { clientX, clientY } = event.touches[0];
    this.touchStart = { x: clientX, y: clientY };
  }

  onTouchEnd(event) {
    if (!this.touchStart) return;

    const { clientX, clientY } = event.changedTouches[0];
    const deltaX = clientX - this.touchStart.x;
    const deltaY = clientY - this.touchStart.y;
    this.touchStart = undefined;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

    // Swiper blocks clicks inside its element after a drag until the next tick,
    // which would cancel the navigation link click below.
    if (this.swiper) this.swiper.allowClick = true;

    if (deltaX < 0) {
      this.nextSlide();
    } else {
      this.prevSlide();
    }
  }
}
